import { z } from "zod";

const count = z.number().int().nonnegative();
const invoiceNumber = z.number().int().positive().nullable();

export const invoiceBatch = z.object({
  invoicesCreated: count,
  lineItemsCreated: count,
  totalAmount: z.number(),
  firstInvoiceNumber: invoiceNumber,
  lastInvoiceNumber: invoiceNumber,
  remainingDone: count,
  remainingInvoiceable: count,
  skippedInvalidPrice: count,
  createdAt: z.string().datetime({ offset: true }),
});
export type InvoiceBatch = z.infer<typeof invoiceBatch>;
